import { render, staticRenderFns } from "./VerticalNavMenuFolderWidget.vue?vue&type=template&id=f8867786"
import script from "./VerticalNavMenuFolderWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VerticalNavMenuFolderWidget.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VerticalNavMenuFolderWidget.vue?vue&type=style&index=0&id=f8867786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports